export default __webpack_public_path__ + "static/media/Hateless Strikes.cf0258a7.jpg";